import { FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram } from "react-icons/fa";
import logo from "../assets/logo.jpg";
import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";
function Footer() {
  return (
    <footer className="bg-brand text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* Top Section */}
        <div className="grid md:grid-cols-3 gap-10">

          {/* Logo + Tagline */}
          <div>
            <img src={logo} alt="Company logo" className="h-20 rounded-full" />
            <p className="mt-3 text-sm text-blue-100">
              Building innovative solutions that empower businesses
              and people to grow through technology.
            </p>
            <p className="mt-3 text-sm text-blue-100">
              CAC Registration Number: RC-15200
              </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-blue-100">
              <li>Email: ogth.africa@gmail.com</li>
              <li>Phone: +234 807 709 5373</li>
              <li>Address: Flat 2, house 5, Malikwu Estate, G.R.A, Agu Akwa Anambra State.</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-blue-100">
              <li>
                <Link to="/" className="hover:text-white hover:translate-x-1 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white hover:translate-x-1 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="program" className="hover:text-white hover:translate-x-1 transition">
                  Our Programs
                </Link>
              </li>

              <li>
                <Link to="/quiz" className="hover:text-white hover:translate-x-1 transition">
                  Quiz
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Newsletter */}

        <NewsletterForm />
        {/* <div className="mt-12 text-center">
          <h3 className="text-xl font-semibold mb-3">
            Subscribe to our Newsletter
          </h3>

          <p className="text-blue-100 mb-6 text-sm">
            Get updates, insights, and resources delivered straight to your inbox.
          </p>

          <form className="flex flex-col sm:flex-row justify-center gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
             className="px-4 py-2 rounded-md text-gray-800 w-full focus:outline-none focus:ring-2 focus:ring-brand-secondary"
            />

            <button
              type="submit"
              className="bg-brand-secondary px-5 py-2 rounded-md font-medium hover:bg-white hover:text-brand transition"
            >
              Subscribe
            </button>
          </form>
        </div> */}

        {/* Divider */}
        <div className="border-t border-brand-secondary my-10"></div>

        {/* Social Icons */}
        <div className="flex justify-center gap-5 mb-6 text-lg">

          <a
            href="https://x.com/4Ogth78674"
            className="w-10 h-10 flex items-center justify-center border border-white rounded-full hover:bg-white hover:text-brand hover:-translate-y-1 transition duration-300"
          >
            <FaTwitter />
          </a>

          <a
            href="https://www.linkedin.com/in/organization-4-global-talents-hunt-ogth-1841a43ab/"
            className="w-10 h-10 flex items-center justify-center border border-white rounded-full hover:bg-white hover:text-brand hover:-translate-y-1 transition duration-300"
          >
            <FaLinkedinIn />
          </a>

          <a href="https://www.instagram.com/ogth_globaltalents/"
            className="w-10 h-10 flex items-center justify-center border border-white rounded-full hover:bg-white hover:text-brand hover:-translate-y-1 transition duration-300"
          >
            <FaInstagram />
          </a>

          <a
            href="https://www.youtube.com/@Organization4GlobalTalentsHunt"
            className="w-10 h-10 flex items-center justify-center border border-white rounded-full hover:bg-white hover:text-brand hover:-translate-y-1 transition duration-300"
          >
            <FaYoutube />
          </a>

        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-blue-100">

          {/* Copyright Left */}
          <p>
            © {new Date().getFullYear()} OGTH. All rights reserved.
          </p>

          {/* Privacy Policy Right */}
          <Link
            to="/privacy-policy"
            className="hover:text-white transition mt-2 md:mt-0 underline"
          >
            Privacy Policy
          </Link>

        </div>

      </div>
    </footer>
  );
}

export default Footer;